import React from "react";
import { observer, inject } from "mobx-react";
import { injectIntl } from "react-intl";
import {
  Row,
  Col,
  Panel,
  ButtonToolbar,
  Button,
  Glyphicon
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Activity from "./Activity";
import { SECTIONS } from "./constantsTooltips";

@injectIntl
@inject("rootStore")
@observer
export default class FinalStep extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { rootStore } = this.props;

    rootStore.tooltipStore.setCurrentSection(SECTIONS.show);
  }

  render() {
    const { intl, rootStore } = this.props;
    const activity = this.props.rootStore.activityStore.activityEdit;
    return (
      <Row>
        <Col xs={12} md={8} mdOffset={2}>
          <Panel className="bmc-activity border-top-6">
            <div id={"activity"}>
              <Activity activity={activity} />
            </div>
          </Panel>
          <br />
          <ButtonToolbar className="bottom-right">
            <LinkContainer to={`/${rootStore.pathPrefixRoute}/new/cost_structure`}>
              <Button>
                <Glyphicon glyph="arrow-left" />
                &nbsp; {intl.formatMessage({ id: "previous" })}
              </Button>
            </LinkContainer>

            <Button bsStyle="primary" onClick={this.handleSubmit}>
              {intl.formatMessage({ id: "save" })}
            </Button>
          </ButtonToolbar>
        </Col>
      </Row>
    );
  }

  handleSubmit() {
    const { rootStore, history, } = this.props;

    rootStore.activityStore.saveEditingActivity();
    history.push(`/${rootStore.pathPrefixRoute}/activities`);
  }
}
